import React, { useState, useEffect } from "react";
import cn from "classnames";
import { noop } from "lib/utils";
import useLayout from "hooks/useLayout";
import useModal from "hooks/useModal";
import useOuterClick from "hooks/useOuterClick";
import A11yElement from "components/helpers/A11yElement";
import ModalPromoForm from "components/ModalPromoForm";

import PromoForm from "./PromoForm";

import { ReactComponent as DiscountIcon } from "static/images/discount.svg";

import "styles/components/promo.scss";
import { trackPromoModal } from "lib/tracking";
import { useGTMChange } from "hooks/useGTM";

const Promo = ({
  onChange = noop,
  promoCode,
  disableInput = false,
}) => {
  const { isMobile } = useLayout();
  const [isOpen, setOpen] = useState(false);
  const { closeModal, showModal } = useModal();
  const refOuterClick = useOuterClick((e) => {
    if (!e.target?.className?.includes?.("icon") && !isMobile) {
      setOpen(false);
    }
  });

  useGTMChange(isOpen, trackPromoModal);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const onClick = () => {
    setOpen(!isOpen);
  };

  const renderDiscount = () => {
    if(!(promoCode && promoCode.promoCode)) {
      return <span>No discount</span>
    } else if (promoCode && !promoCode.discountAmount && promoCode.promoCode) {
      return <span>{promoCode.promoCode}</span>
    }
    return <span>{`${promoCode.discountAmount}% off`}</span>
  }

  useEffect(() => {
    if (isOpen && isMobile) {
      showModal(<ModalPromoForm onClose={closeModal} onChange={onChange} promoCode={promoCode} />, { onClose: handleCloseModal });
    }
  }, [isOpen, promoCode]);

  return (
    <div
      className={cn("otrl-jp__promo-container", {
        "otrl-jp__promo-container--disabled": disableInput,
      })}
      ref={refOuterClick}
    >
      <A11yElement
        role="button"
        className={cn("otrl-jp__promo", {
          "otrl-jp__promo--opened": isOpen,
        })}
        onAction={onClick}
        tabIndex={disableInput ? "-1" : "0"}
      >
        <div className="otrl-jp__promo__button">
          <DiscountIcon className="otrl-jp__promo__icon" />
          <div className="otrl-jp__promo__group">
            <span className="otrl-jp__promo__type">Promo&nbsp;code</span>
            <div className="otrl-jp__promo__second-row">
              {renderDiscount()}
            </div>
          </div>
        </div>
      </A11yElement>

      <div className="otrl-jp__promo__dropdown">
        {!isMobile && isOpen && <PromoForm onChange={onChange} promoCode={promoCode} />}
      </div>
    </div>
  );
};

export default Promo;
